
function guestAssetPackDownloadSuccessDialog () {
  return {
    restrict: 'E',
    templateUrl: '/guest/dialogs/guest-asset-pack-download-success/guest-asset-pack-download-success.html?$$REVISION$$'
  }
}

export { guestAssetPackDownloadSuccessDialog }
